define("calendar/components/calendar/context-menu", ["exports", "@ember/component", "@ember/object", "@ember/template", "@glimmer/component", "@glimmer/tracking", "shared/utils/constants/keys", "shared/utils/handle-key-up", "@ember/template-factory"], function (_exports, _component, _object, _template, _component2, _tracking, _keys, _handleKeyUp, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _handleKeyPress, _handleLeftClick, _handleRightClick;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/template",0,"@glimmer/component",0,"@glimmer/tracking",0,"shared/utils/constants/keys",0,"shared/utils/handle-key-up",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateFieldGet(e, t) { var r = _classPrivateFieldGet2(t, e); return _classApplyDescriptorGet(e, r); }
  function _classPrivateFieldGet2(s, a) { return s.get(_assertClassBrand(s, a)); }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div
    class="o--dropWrapper cCA--dropDown eCA--dropDown {{unless @visible 'u--hide'}}"
    style={{this.dynamicStyling}}
    {{did-insert this.addListeners}}
    {{did-update this.renderMenu @left @top}}
    {{will-destroy this.removeListeners}}
  >
    <div class="o--dropBody">
      <Shared::Ui::Button
        @additional="block"
        @class="qa--calendar_right_click_menu qa--calendar_right_click_create_note"
        @onClick={{@createNewCalendarNote}}
        @variant="outline"
      >
        {{svg-jar "notes" class="o--icon u--m__r__xs"}}
        {{t "calendar_notes.add_note"}}
      </Shared::Ui::Button>
  
      {{#if @post}}
        <Shared::Ui::Button
          @additional="block"
          @class="qa--calendar_right_click_menu qa--calendar_right_click_copy_post"
          @onClick={{@copyPost}}
          @variant="outline"
        >
          {{svg-jar "copy" class="o--icon u--m__r__xs"}}
          {{t "post.copy_post.copy_post"}}
        </Shared::Ui::Button>
        {{#if @post.canDeletePost}}
          <Shared::Ui::Button
            @additional="block"
            @class="qa--calendar_right_click_menu qa--calendar_right_click_delete_post"
            @onClick={{@deletePost}}
            @variant="outline"
          >
            {{svg-jar "trash" class="o--icon u--m__r__xs"}}
            {{t "shared_words.delete"}}
          </Shared::Ui::Button>
        {{/if}}
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "olmdPQnY",
    "block": "[[[11,0],[16,0,[29,[\"o--dropWrapper cCA--dropDown eCA--dropDown \",[52,[51,[30,1]],\"u--hide\"]]]],[16,5,[30,0,[\"dynamicStyling\"]]],[4,[38,1],[[30,0,[\"addListeners\"]]],null],[4,[38,2],[[30,0,[\"renderMenu\"]],[30,2],[30,3]],null],[4,[38,3],[[30,0,[\"removeListeners\"]]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--dropBody\"],[12],[1,\"\\n    \"],[8,[39,4],null,[[\"@additional\",\"@class\",\"@onClick\",\"@variant\"],[\"block\",\"qa--calendar_right_click_menu qa--calendar_right_click_create_note\",[30,4],\"outline\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,5],[\"notes\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n      \"],[1,[28,[35,6],[\"calendar_notes.add_note\"],null]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,5],[[[1,\"      \"],[8,[39,4],null,[[\"@additional\",\"@class\",\"@onClick\",\"@variant\"],[\"block\",\"qa--calendar_right_click_menu qa--calendar_right_click_copy_post\",[30,6],\"outline\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,5],[\"copy\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n        \"],[1,[28,[35,6],[\"post.copy_post.copy_post\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"],[41,[30,5,[\"canDeletePost\"]],[[[1,\"        \"],[8,[39,4],null,[[\"@additional\",\"@class\",\"@onClick\",\"@variant\"],[\"block\",\"qa--calendar_right_click_menu qa--calendar_right_click_delete_post\",[30,7],\"outline\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,5],[\"trash\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n          \"],[1,[28,[35,6],[\"shared_words.delete\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@visible\",\"@left\",\"@top\",\"@createNewCalendarNote\",\"@post\",\"@copyPost\",\"@deletePost\"],false,[\"unless\",\"did-insert\",\"did-update\",\"will-destroy\",\"shared/ui/button\",\"svg-jar\",\"t\",\"if\"]]",
    "moduleName": "calendar/components/calendar/context-menu.hbs",
    "isStrictMode": false
  });
  let ContextMenuComponent = _exports.default = (_class = (_handleKeyPress = /*#__PURE__*/new WeakMap(), _handleLeftClick = /*#__PURE__*/new WeakMap(), _handleRightClick = /*#__PURE__*/new WeakMap(), class ContextMenuComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "width", _descriptor, this);
      _initializerDefineProperty(this, "height", _descriptor2, this);
      _initializerDefineProperty(this, "menu", _descriptor3, this);
      _classPrivateFieldInitSpec(this, _handleKeyPress, {
        writable: true,
        value: event => {
          (0, _handleKeyUp.default)(event, _keys.default.ESCAPE, () => {
            this.args.hideContextMenu();
          });
        }
      });
      _classPrivateFieldInitSpec(this, _handleLeftClick, {
        writable: true,
        value: event => {
          if (!this.menu) {
            return;
          }
          if (!this.menu.contains(event.target) && !this.isDestroyed && this.args.visible) {
            this.args.hideContextMenu();
          }
        }
      });
      _classPrivateFieldInitSpec(this, _handleRightClick, {
        writable: true,
        value: event => {
          const calendar = document.querySelector('#calendar');
          if (!calendar) {
            return;
          }
          if (!calendar.contains(event.target) && !this.isDestroyed) {
            this.args.hideContextMenu();
          }
        }
      });
    }
    get dynamicStyling() {
      return (0, _template.htmlSafe)(`left: ${this.leftOffset}; top: ${this.topOffset};`);
    }
    get leftOffset() {
      const windowWidth = window.innerWidth;
      const left = Math.min(windowWidth - this.width, this.args.left);
      return left + 'px';
    }
    get topOffset() {
      const windowHeight = window.innerHeight;
      const top = Math.min(windowHeight - this.height, this.args.top);
      return top + 'px';
    }
    addListeners() {
      document.addEventListener('mousedown', _classPrivateFieldGet(this, _handleLeftClick));
      // Triggered when right clicking somewhere not producing custom context menu.
      document.addEventListener('contextmenu', _classPrivateFieldGet(this, _handleRightClick));
      document.addEventListener('keyup', _classPrivateFieldGet(this, _handleKeyPress));
    }
    removeListeners() {
      document.removeEventListener('mousedown', _classPrivateFieldGet(this, _handleLeftClick));
      document.removeEventListener('contextmenu', _classPrivateFieldGet(this, _handleRightClick));
      document.removeEventListener('keyup', _classPrivateFieldGet(this, _handleKeyPress));
    }
    renderMenu(menu) {
      this.menu = menu;
      this.width = menu?.offsetWidth;
      this.height = menu?.offsetHeight;
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "width", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "height", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "menu", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "addListeners", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addListeners"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeListeners", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeListeners"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "renderMenu", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "renderMenu"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ContextMenuComponent);
});